import type { User } from '@datadog/browser-core'
import { DecodedToken } from '@wm-front/shared/interfaces'

/** Extract the user from decodedToken for datadog service
 * @param { DecodedToken } decodedToken
 */
export function getDatadogUser(decodedToken: DecodedToken | null): User {
  let user: User = {}

  if (decodedToken) {
    const id =
      typeof decodedToken.id === 'string'
        ? decodedToken.id
        : decodedToken.id !== undefined && decodedToken.id >= 0
        ? decodedToken.id.toString()
        : undefined
    user = {
      email: decodedToken.email,
      name: decodedToken.name ? decodedToken.name : undefined,
      id,
      ...decodedToken.payload,
    }
  }

  return user
}
